import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import RenderHTML from "../utils/RenderHtml";
import Page from "../utils/Page";
import { BASE_URL, SITE_NAME, SITE_INFO_EMAIL } from '../utils/constants';


const Terms = (props) => {
  useEffect(() => {
    window.scroll(0, 0);
  }, [])
  const copyWithDomainReplaced = props.data.replaceAll('{SITE_NAME}', SITE_NAME)
  return (
    <Page
      id="terms"
    >
      <div className="product-page">
        <RenderHTML HTML={copyWithDomainReplaced} />
      </div >
    </Page >
  );
};

export default Terms;





